module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Rzc0f9/tc-custom/9783956763311_IMGJPG_FrontCover_0.jpg?1703129345393",
      "alt": "This image is the cover for the book Die Versuchung des Pescara, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Die Versuchung des Pescara, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"Die Versuchung des Pescara\" ist eine Novelle von C.F. Meyer. Sie wurde 1887 veröffentlicht und gilt als eines seiner bedeutendsten Werke. Die Erzählung spielt im Italien des frühen 16. Jahrhunderts. In dieser Zeit ist Italien politisch in Stadtstaaten und diverse Fürstentümer im Norden, den Kirchenstaat im Zentrum und das spanisch beherrschte Neapel im Süden zersplittert. Aufgrund des relativen Reichtums der italienischen Stadtstaaten kam es immer wieder zu Krieg über den Besitz Nord- und Süditaliens, mit häufig wechselnden Allianzen, die Verrat zu einem Merkmal der Epoche machen...(Auszug aus Wikipedia)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Conrad Ferdinand Meyer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Conrad Ferdinand Meyer (* 11. Oktober 1825 in Zürich; † 28. November 1898 in Kilchberg bei Zürich) war ein Schweizer Dichter des Realismus, der (insbesondere historische) Novellen, Romane und Lyrik geschaffen hat. Er gehört mit Gottfried Keller und Jeremias Gotthelf zu den bedeutendsten deutschsprachigen Schweizer Dichtern des 19. Jahrhunderts. (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0